var MegaMenu = function(options) {
  var $allMegaMenu = $();

  // Clicking should go to the link instead of opening the dropdown
  const xlScreenSize = 1260;
  if ($(window).width() >= xlScreenSize) {
    $(this, options.container).removeAttr('data-toggle');
  } else {
    $(this, options.container).attr('data-toggle', 'dropdown');
  }

  // the element we really care about
  // is the dropdown's parent
  $allMegaMenu = $allMegaMenu.add($(this).parent());

  // Preload images
  let elements = $("a:hidden", options.container);

  $.each(elements, function(index, element) {
    const url = $(element).css("background-image").replace(/^url\(['"](.+)['"]\)/, '$1');
    if (url !== 'none') {
      const image = new Image();
      image.src = url;
    }
  });

  return $(this, options.container).each(function () {
    var $this = $(this),
      $parent = $this.parent(),
      $next = $this.parent().find('.dropdown-menu'),
      defaults = {
        delay: 100,
        hoverDelay: 100
      },
      settings = $.extend(true, {}, defaults, options),
      timeout, timeoutHover;

    $parent.hover(function (event) {
      openMenu(event);
    }, function () {
      // clear timer for hover event
      window.clearTimeout(timeoutHover)
      timeout = window.setTimeout(function () {
        $parent.removeClass('show');
        $next.removeClass('show');
      }, settings.delay);
    });

    function openMenu(event) {
      // clear dropdown timeout here so it doesnt close before it should
      window.clearTimeout(timeout);
      // restart hover timer
      window.clearTimeout(timeoutHover);

      // delay for hover event
      timeoutHover = window.setTimeout(function () {
        $allMegaMenu.find(':focus').blur();

        // clear timer for hover event
        window.clearTimeout(timeoutHover);
        $parent.addClass('show');
        $next.addClass('show');
      }, settings.hoverDelay);
    }
  });
}

export default MegaMenu;



//////////////////
// WEBPACK FOOTER
// ./node_modules/styleguide/resources/assets/js/mega-menu.js
// module id = 1201
// module chunks = 56